import {galleryGlobalsStrategy} from '../../../gallery/galleryGlobalStrategy';
import {getWrappedComponent} from '../../../appConfig';
import stylesParams from '../stylesParams';
import {ExtendedGridGallery} from '../../../common/ExtendedGridGallery/ExtendedGridGallery';

export default getWrappedComponent({
  Component: ExtendedGridGallery,
  stylesParams,
  globalPropsStrategy: galleryGlobalsStrategy,
  sliderGallery: false,
});
